import { render } from "./OrganismsChart.vue?vue&type=template&id=6063871b&scoped=true&ts=true"
import script from "./OrganismsChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsChart.vue?vue&type=script&lang=ts&setup=true"

import "./OrganismsChart.vue?vue&type=style&index=0&id=6063871b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6063871b"],['__file',"src/components/organisms/OrganismsChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6063871b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6063871b', __exports__)) {
    api.reload('6063871b', __exports__)
  }
  
  module.hot.accept("./OrganismsChart.vue?vue&type=template&id=6063871b&scoped=true&ts=true", () => {
    api.rerender('6063871b', render)
  })

}


export default __exports__